import type { MatchRow } from './types';

export interface Implied {
  home: number;
  draw: number;
  away: number;
}

export function impliedProbs(m: Pick<MatchRow, 'ml_home' | 'ml_draw' | 'ml_away'>): Implied | null {
  if (!m.ml_home || !m.ml_draw || !m.ml_away) return null;
  if (m.ml_home <= 1 || m.ml_draw <= 1 || m.ml_away <= 1) return null;
  const rH = 1 / m.ml_home, rX = 1 / m.ml_draw, rA = 1 / m.ml_away;
  const s = rH + rX + rA;
  return { home: rH / s, draw: rX / s, away: rA / s };
}

export function fmtOdds(v: number | null): string {
  if (v == null) return '—';
  return v.toFixed(2);
}
